/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";

import {
  Title,
  Select,
  GoBack,
  Message,
  InputField,
  PhoneInput,
  ActionButton,
  TextArea,
} from "../../component/Component";

import {
  codeOk,
  codeCreate,
  errorMessage,
} from "../../../../middlewares/index";

import { useTeamContext } from "../../../../context/team/TeamContext";
import { defaultImage } from "../../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { FOLDERS } from "../../../doseeData/utils/Utils";

const Add = () => {
  const { createOneTeam } = useTeamContext();

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [status, setStatus] = useState(0);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [firstname, setFirstName] = useState(null);
  const [lastname, setLastName] = useState(null);
  const [country, setCountry] = useState(null);
  const [city, setCity] = useState(null);
  const [address, setAddress] = useState(null);
  const [phonenumber, setPhoneNumber] = useState(null);
  const [email, setEmail] = useState(null);
  const [role, setRole] = useState(null);
  const [description, setDescription] = useState(null);
  const [teamStatus, setTeamStatus] = useState(1);

  const teamRoutes = "/team";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setFirstName(null);
    setLastName(null);
    setCountry(null);
    setCity(null);
    setAddress(null);
    setPhoneNumber(null);
    setThumbnail(null);
    setThumbnailId(null);
    setDescription(null);
  };

  const responses = (isError, _status, _message) => {
    setError(isError);
    setStatus(_status);
    setErrorMessage(_message);
  };

  const addOneTeamHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      return responses(true, 400, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      email_address: email,
      firstname: firstname,
      lastname: lastname,
      password: "000000",
      country: country,
      city: city,
      address: address,
      phone_number: phonenumber,
      role: role,
      description: description,
      status: teamStatus,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "...",
    };

    const response = await createOneTeam(data);
    if (response) {
      if (response.data.status === codeOk || response.data.status === codeCreate) {
        cleanFields();
        return responses(false, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  const hasPhoto = !!thumbnailId && thumbnailId !== "img_cdn_id";

  return (
    <div className="h-full overflow-y-auto bg-gray-50 p-4 rounded-b-xl">
      <div className="mx-auto max-w-6xl">
        <GoBack props={{ route: teamRoutes }} />

        {/* Header / Intro */}
        <div className="relative mt-3 mb-5">
          <div className="pointer-events-none absolute -inset-x-6 -top-6 h-24 rounded-3xl bg-gradient-to-r from-emerald-400/15 via-amber-400/15 to-fuchsia-400/15 blur-2xl -z-10" />
          <div className="relative rounded-2xl border border-gray-200 bg-white/90 shadow-sm backdrop-blur">
            <div className="flex flex-col gap-4 p-5 md:flex-row md:items-center md:justify-between">
              <div>
                <h1 className="text-base font-semibold tracking-tight text-gray-900">
                  Add Team Member
                </h1>
                <p className="mt-0.5 text-xs text-gray-600">
                  Upload a profile photo and enter identity & contact details.
                </p>
              </div>

              <div className="flex flex-wrap items-center gap-2">
                <StatusChip label="Profile Photo" ok={hasPhoto} />
              </div>
            </div>
          </div>
        </div>

        {/* Global messages */}
        <Message
          props={{
            error: error,
            success: success,
            message: message,
            loading: loading,
            status: status,
            onClick: () => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            },
          }}
        />

        <form onSubmit={addOneTeamHandler} className="space-y-5">
          {/* Brand / Photo */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3 flex items-center justify-between">
              <Title props={{ title: "Profile Photo" }} />
              <span className="text-[11px] text-gray-500">JPEG/PNG — square recommended</span>
            </div>

            <div className="rounded-xl border border-dashed border-gray-200 p-3">
              <ImageKitUpload
                thumbnail={thumbnail}
                thumbnailId={thumbnailId}
                setThumbnail={setThumbnail}
                setThumbnailId={setThumbnailId}
                folder={FOLDERS.TEAM}
              />
            </div>
          </section>

          {/* Identity */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3">
              <Title props={{ title: "Member Details" }} />
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              <InputField
                props={{
                  id: "firstname",
                  title: "First Name",
                  type: "text",
                  value: firstname ? firstname : "",
                  onChange: (e) => {
                    setFirstName(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "lastname",
                  title: "Last Name",
                  type: "text",
                  value: lastname ? lastname : "",
                  onChange: (e) => {
                    setLastName(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "role",
                  title: "Role",
                  type: "text",
                  value: role ? role : "",
                  onChange: (e) => {
                    setRole(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "country",
                  title: "Country",
                  type: "text",
                  value: country ? country : "",
                  onChange: (e) => {
                    setCountry(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "city",
                  title: "City",
                  type: "text",
                  value: city ? city : "",
                  onChange: (e) => {
                    setCity(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "address",
                  title: "Address",
                  type: "text",
                  value: address ? address : "",
                  onChange: (e) => {
                    setAddress(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </section>

          {/* Contact */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3">
              <Title props={{ title: "Contact Info" }} />
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
              <div className="flex items-center">
                <PhoneInput setPhone={setPhoneNumber} phone={phonenumber} required={true} />
              </div>
              <InputField
                props={{
                  id: "email",
                  title: "Email Address",
                  type: "email",
                  required: true,
                  value: email ? email : "",
                  onChange: (e) => {
                    setEmail(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </section>

          {/* Settings */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3">
              <Title props={{ title: "Settings" }} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              <Select
                props={{
                  id: "event_status",
                  title: "Status",
                  option: ["visible", "invisible"],
                  onChange: (e) => {
                    if (e.target.selectedIndex === 0) setTeamStatus(1);
                    else setTeamStatus(0);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>

            <div className="mt-4">
              <TextArea
                props={{
                  id: "description",
                  title: "Description",
                  type: "text",
                  value: description ? description : "",
                  onChange: (e) => {
                    setDescription(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </section>

          {/* Action */}
          <div className="flex items-center justify-end">
            <div className="w-full rounded-xl bg-white shadow-sm ring-1 ring-gray-200 p-2">
              <ActionButton
                props={{
                  title: "Add Member",
                  error: error,
                  success: success,
                  message: message,
                  loading: loading,
                  status: status,
                  onClick: () => {
                    setError(false);
                    setSuccess(false);
                    setErrorMessage("");
                  },
                }}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Add;

const StatusChip = ({ label, ok }) => (
  <span
    className={[
      "inline-flex items-center gap-2 rounded-full px-2.5 py-1 text-[11px] font-medium ring-1",
      ok ? "bg-emerald-50 text-emerald-700 ring-emerald-200" : "bg-gray-50 text-gray-600 ring-gray-200",
    ].join(" ")}
  >
    <span className={["h-1.5 w-1.5 rounded-full", ok ? "bg-emerald-500" : "bg-gray-300"].join(" ")} />
    {label}
  </span>
);
